import React from 'react';

class SEOErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log SEO-related errors
    console.error('SEO Error:', error, errorInfo);
    
    // You can also log the error to an error reporting service
    if (process.env.NODE_ENV === 'production') {
      // logErrorToService(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render basic SEO fallback
      return (
        <>
          <title>بديل - منصة المختبرات الطبية</title>
          <meta 
            name="description" 
            content="منصة بديل الرائدة في المملكة العربية السعودية لتبادل وبيع معدات المختبرات الطبية" 
          />
          <meta name="robots" content="index, follow" />
          {this.props.children}
        </>
      );
    }

    return this.props.children;
  }
}

export default SEOErrorBoundary;
